<template>
    <div class="row">
        <div class="col-8 mx-auto justify-content-center">
            <div class="row justify-content-center dashboardstyle m-2">
                <canvas ref="chart"></canvas>
            </div>
        </div>

    </div>

    
</template>

<script>
    import {Chart} from 'chart.js';
    export default{

        data() {
            return {                                               
                testGraph: null, 
                time_horizon: 10, 
                equity: 0.4,
                fixed_income: 0.3,
                alternative: 0.2,
                cash: 0.1,  
                updateInterval: 1000,  
                rand: 0.5,          
            }                      
        },  


        mounted() {    
            var ctx = this.$refs.chart.getContext('2d');
            var gradient = ctx.createLinearGradient(0, 0, 0, 400);
            var gradient_bis = ctx.createLinearGradient(1, 0, 0, 400);

            gradient.addColorStop(0, 'rgba(56, 103, 214,0.3)');
            gradient.addColorStop(0.5, 'rgba(253, 180, 75,0.1)');
            gradient.addColorStop(1, 'rgba(56, 103, 214, 0.3)');

            gradient_bis.addColorStop(0, 'rgba(56, 103, 214,0.3)');
            gradient_bis.addColorStop(0.5, 'rgba(253, 180, 75,0.1)');
            gradient_bis.addColorStop(1, 'rgba(56, 103, 214, 0.3)');

            this.testGraph = new Chart(ctx, {
                type: 'bar',
                data: {
                    labels: [],
                    datasets: [
                        {
                            label: 'Actions | myfo',
                            data: [],
                            fill: true,
                            backgroundColor: 'rgba(56, 103, 214, .4)',
                            fontFamily: "Poppins",
                            stack: 1,
                        },
                        {
                            label: 'Obligations | myfo',
                            data: [],
                            fill: true,
                            backgroundColor: 'rgba(56, 103, 214, .6)',
                            fontFamily: "Poppins",
                            stack: 1,
                        },
                        {
                            label: 'Alternative | myfo',
                            data: [],
                            fill: true,
                            backgroundColor: 'rgba(56, 103, 214, .8)',
                            fontFamily: "Poppins",
                            stack: 1,
                        },
                        {
                            label: 'Cash | myfo',
                            data: [],
                            fill: true,
                            backgroundColor: 'rgba(56, 103, 214, 1)',
                            fontFamily: "Poppins",
                            stack: 1,
                        },
                        {
                            label: 'Actions | Compétition',
                            data: [],
                            fill: true,
                            backgroundColor: 'rgba(253, 180, 75,.4)',
                            fontFamily: "Poppins",
                            stack: 2,
                        },
                        {
                            label: 'Obligations | Compétition',
                            data: [],
                            fill: true,
                            backgroundColor: 'rgba(253, 180, 75,.6)',
                            fontFamily: "Poppins",
                            stack: 2,
                        },
                        {
                            label: 'Alternative | Compétition',
                            data: [],
                            fill: true,
                            backgroundColor: 'rgba(253, 180, 75,.8)',
                            fontFamily: "Poppins",
                            stack: 2,
                        },
                        {
                            label: 'Cash | Compétition',
                            data: [],
                            fill: true,
                            backgroundColor: 'rgba(253, 180, 75,1)',
                            fontFamily: "Poppins",
                            stack: 2,
                        },
                    ],
                },
    
                options: {
                    legend: {
                        position: 'bottom',
                        labels: {
                            fontFamily: 'Poppins',
                            fontSize: 11,
                            fontColor: '#333'
                        }
                        },
                    scales: {
                        tooltips: {
                            titleFontFamily: "Poppins",
                            titleFontStyle: 'normal',
                            bodyFontFamily: 'Poppins'
                        },
                        yAxes:[
                            {
                                stacked: true,
                                ticks: {
                                    beginAtZero: false,
                                    fontFamily: "Poppins",
                                    fontColor: 'rgb(169,169,169)',
                                    fontSize: 10,
                                },
                                gridLines: {
                                    offsetGridLines: true,
                                    display:false
                                },
                            }
                        ],
                        xAxes:[
                            {
                                ticks: {
                                    fontFamily: "Poppins",
                                    fontColor: 'rgb(56, 103, 214)',
                                    fontSize: 10,
                                },
                                gridLines: {
                                    offsetGridLines: true,
                                    display:false
                                },
                                stacked: true,
                            }
                        ]
                    }
                }
            });
            setInterval(() => (
                  this.onDataChange()), 3000);
                        
        },
                
        methods: {  
            onDataChange(){    
                // calcul ici data_av et data_ct en fonction de this.amount, this.time_horizon et this.performance
                this.rand = Math.random();

                var labels = [];
                var data_myfo_equity = [];
                var data_myfo_fixed_income = [];
                var data_myfo_alternative = [];
                var data_myfo_cash = [];

                var data_peer_equity = [];
                var data_peer_fixed_income = [];
                var data_peer_alternative = [];
                var data_peer_cash = [];

                var sensitivity_parameters = ['0.1','0.3','0.6','0.8','1','1','1.1','1.2','1.3','1.4'];

                var e_parameters = ['0.0','0.0909','0.1905','0.2857','0.3636','0.4348','0.5','0.56','0.6154','0.72'];
                var fi_parameters = ['0.8696','0.81.82','0.7619','0.6667','0.5455','0.4348','0.3333','0.24','0.1538','0'];
                var alt_parameters = ['0.0','0.0','0.0','0.0','0.0455','0.087','0.125','0.16','0.1923','0.24'];
                var c_parameters = ['0.1304','0.0909','0.0476','0.0476','0.0455','0.0435','0.0417','0.04','0.0385','0.04'];

                var saa = ['0.4','0.4','0.15','0.05']

                //var rand = Math.random();

                labels[0] = "MP";
                data_myfo_equity[0] = this.rand*0.7;
                data_myfo_fixed_income[0] = (1-this.rand)*0.7;
                data_myfo_alternative[0] = this.rand*0.3;
                data_myfo_cash[0] = (1-this.rand)*0.3;

                data_peer_equity[0] = 0.5*0.7;
                data_peer_fixed_income[0] = 0.5*0.7;
                data_peer_alternative[0] = 0.5*0.3;
                data_peer_cash[0] = 0.5*0.3;

                for (let year = 1; year <= this.time_horizon; year++)
                {
                    labels[year] = "PR " + (parseFloat(year));
                    data_myfo_cash[year] = Math.min(1,Math.max(0,(parseFloat(c_parameters[year-1])+parseFloat(sensitivity_parameters[year-1])*(data_myfo_cash[0]-parseFloat(saa[3])))));
                    data_myfo_fixed_income[year] = Math.max(0,Math.min((parseFloat(fi_parameters[year-1])+parseFloat(sensitivity_parameters[year-1])*(data_myfo_fixed_income[0]-parseFloat(saa[1]))),(1-data_myfo_cash[year])));
                    data_myfo_equity[year] = Math.max(0,Math.min((parseFloat(e_parameters[year-1])+parseFloat(sensitivity_parameters[year-1])*(data_myfo_equity[0]-parseFloat(saa[0]))),(1-data_myfo_cash[year]-data_myfo_fixed_income[year])));
                    data_myfo_alternative[year] = Math.max(0,Math.min((parseFloat(alt_parameters[year-1])+parseFloat(sensitivity_parameters[year-1])*(data_myfo_alternative[0]-parseFloat(saa[2]))),(1-data_myfo_cash[year]-data_myfo_fixed_income[year]-data_myfo_equity[year])));
                    
                    data_peer_equity[year] = data_peer_equity[0];
                    data_peer_fixed_income[year] = data_peer_fixed_income[0];
                    data_peer_alternative[year] = data_peer_alternative[0];
                    data_peer_cash[year] = data_peer_cash[0];
                }
                
                this.testGraph.data.labels = labels;
                this.testGraph.data.datasets[0].data = data_myfo_equity;
                this.testGraph.data.datasets[1].data = data_myfo_fixed_income;
                this.testGraph.data.datasets[2].data = data_myfo_alternative;
                this.testGraph.data.datasets[3].data = data_myfo_cash;
                
                this.testGraph.data.datasets[4].data = data_peer_equity;
                this.testGraph.data.datasets[5].data = data_peer_fixed_income;
                this.testGraph.data.datasets[6].data = data_peer_alternative;
                this.testGraph.data.datasets[7].data = data_peer_cash;
                this.testGraph.update();
            },            
        }
        
        
    }  

</script>